import {
  generateMimeFromType,
  getPathiconForMimetype
} from "@pathwright/media-utils"
import { MEDIA_TYPES } from "@pathwright/ux/src/components/filestack/constants"

export const previewAttachmentData = [
  {
    url: "https://cdn.filestackcontent.com/preview/nI4HPYGS2SskUwTLBlKt",
    mediaID: "",
    thumb: "",
    name: "readme.txt",
    mimetype: "text/plain",
    filestackHandle: "nI4HPYGS2SskUwTLBlKt",
    mediaType: MEDIA_TYPES.FILE
  },
  {
    url: "https://cdn.filestackcontent.com/preview/CJP0teQQcq3reDgEkv4s",
    mediaID: "",
    thumb: "https://cdn.filestackcontent.com/CJP0teQQcq3reDgEkv4s",
    name: "Sailing_Boat.jpg",
    mimetype: "image/jpeg",
    filestackHandle: "CJP0teQQcq3reDgEkv4s",
    mediaType: MEDIA_TYPES.IMAGE
  }
]

const cleanMediaItem = (mediaItem) =>
  Object.keys(mediaItem).reduce((cleanedMediaItem, key) => {
    if (mediaItem[key] === null) return cleanedMediaItem
    return {
      ...cleanedMediaItem,
      [key]: mediaItem[key]
    }
  }, {})

// Create an Attachment block from a Media item
export const mediaToAttachment = (mediaItem) => {
  const {
    url,
    downloadURL,
    mimetype,
    name,
    id,
    type,
    thumb,
    externalID,
    muxVideoID,
    size
  } = mediaItem

  const fileSize = size ? size.fileSize : null

  return cleanMediaItem({
    mediaID: id,
    // Some legacy data may not have a downloadURL for videos,
    //  so fallback to url
    url: type === MEDIA_TYPES.VIDEO ? downloadURL || url : url,
    mimetype: mimetype || generateMimeFromType(type),
    name,
    mediaType: type,
    thumb: thumb ? thumb.original : null,
    filestackHandle: externalID,
    muxVideoID,
    fileSize
  })
}

// Placeholder — the blocks framework doesn't like an empty attachments array
export const getPlaceholder = () => {
  return {
    mediaID: "emptyID",
    url: "empty",
    name: "empty",
    mimetype: "none",
    mediaType: MEDIA_TYPES.FILE
  }
}

// Merge new attachment with existing, ommiting placeholder
export const mergeAttachments = (files, attachment) => {
  const trimmed = files.filter((file) => file.name !== "empty")
  return [...trimmed, attachment]
}

// Remove target attachment, adding placeholder if needed
export const unMergeAttachment = (prevFiles, index) => {
  const files = prevFiles.slice()
  files.splice(index, 1)
  // const files = prevFiles.filter(
  //   attachment => attachment.mediaID !== attachmentToRemove.mediaID
  // )

  // The blocks framework doesn't like an empty files array
  if (!files.length) {
    files[0] = getPlaceholder()
  }

  return files
}

// Remove target attachment, adding placeholder if needed
export const updateAttachment = (allFiles, attachmentToUpdate) => {
  const returnedFiles = allFiles.reduce((nextFiles, file) => {
    const addToFiles =
      file.mediaID === attachmentToUpdate.mediaID
        ? { ...attachmentToUpdate }
        : { ...file }

    nextFiles.push(addToFiles)
    return nextFiles
  }, [])
  return returnedFiles
}

export const attachmentsAreEmpty = (attachments) => {
  return (
    attachments && attachments.length === 1 && attachments[0].name === "empty"
  )
}

// Given a media type (image, etc.) and thumbnail object,
//  get preview type and media
export const getAttachmentPreview = (attachment) => {
  const { url, thumb, mimetype, mediaType } = attachment

  let preview
  if (!thumb && mediaType === MEDIA_TYPES.IMAGE) {
    preview = url
  } else {
    preview = thumb || getPathiconForMimetype(mimetype)
  }

  const previewType =
    thumb || mediaType === MEDIA_TYPES.IMAGE ? "thumb" : "icon"

  return { preview, previewType }
}
